module.exports = __webpack_public_path__ + "media/components/src/assets/images/gallery_3-be92a15d58dfbaac97d40acbb0f31417.jpg";